import ApiService from '@/services/core/api.service'

const SReport = {

  async getQRPh (query = '') {
    return ApiService.get(`merchant/reports/qrph?${query}`)
  }

  // async getQRPh (query = '') {
  //   return ApiService.get(`merchant/reports/qrph?${query}`)
  // },

  // async getGCash (query = '') {
  //   return ApiService.get(`merchant/reports/gcash-h5?${query}`)
  // },

  // async getSwiftPay (query = '') {
  //   return ApiService.get(`merchant/reports/swiftpay-gcash?${query}`)
  // }

}

export default SReport
